import React from "react";
import { Skeleton } from "./Skeleton";

/** Shimmer placeholder for buttons and inline rows (replaces spinners). */
export function InlineLoadSkeleton({ className = "h-4 w-4 rounded shrink-0" }) {
  return <Skeleton className={`inline-block align-middle ${className}`} />;
}

export default InlineLoadSkeleton;
